// src/app/features/document/services/DocumentService/document.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private apiUrl = `${environment.apiUrl}/documents`;

  constructor(private http: HttpClient) {}

  getDocuments(filter: any): Observable<any[]> {
    // Add query params based on the filter object
    const params = new URLSearchParams();
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        params.append(key, filter[key]);
      }
    });
    return this.http.get<any[]>(`${this.apiUrl}?${params.toString()}`);
  }

  createDocument(document: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, document);
  }

  updateDocument(id: number, document: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, document);
  }

  deleteDocument(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }

  visualizarDocumento(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}/visualizar`);
  }

  downloadDocumento(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/download`, { responseType: 'blob' });
  }

  exportarDocumentos(filter: any): Observable<Blob> {
    const params = new URLSearchParams();
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        params.append(key, filter[key]);
      }
    });
    return this.http.get(`${this.apiUrl}/exportar?${params.toString()}`, { responseType: 'blob' });
  }

  imprimirDocumento(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/imprimir`, { responseType: 'blob' });
  }

  compartilharDocumento(id: number, shareDetails: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${id}/compartilhar`, shareDetails);
  }

  verificarPermissao(acao: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/permissao/${acao}`);
  }
}